import { useState, useEffect } from "react";
import useConfig from "hooks/useConfig";
import { LAYOUT_BREAKPOINTS } from "config";

const getWindowDimensions = ({ vertical } = {}) => {
  const { innerWidth: width, innerHeight: height } = window;

  const isTablet = width <= LAYOUT_BREAKPOINTS.TABLET_XS || !!vertical;
  const isMobile = width <= LAYOUT_BREAKPOINTS.MOBILE || !!vertical;
  const isDesktop = !isMobile;
  const isDesktopDevice = width > LAYOUT_BREAKPOINTS.MOBILE;

  return {
    width,
    height,
    isTablet,
    isMobile,
    isDesktop,
    isDesktopDevice
  };
};

const useLayout = debug => {
  const { vertical = false } = useConfig();
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions({ vertical }));

  useEffect(() => {
    const handleResize = () => {
      setWindowDimensions(getWindowDimensions({ vertical }));
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [debug, vertical]);

  return windowDimensions;
};

export default useLayout;
